module.exports = __webpack_public_path__ + "static/media/logo-omnyve.bfb87fbc.svg";